module.exports = __webpack_public_path__ + "img/image-airfilter.3932cf7e.jpg";